import { initialState } from './reducers'

export const select = (state) => state || initialState

export const selectDitmState = (state) => select(state).ditm?.ditmState
